import { render, staticRenderFns } from "./pa_radioset.vue?vue&type=template&id=229688f5&scoped=true"
import script from "./pa_radioset.vue?vue&type=script&lang=js"
export * from "./pa_radioset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229688f5",
  null
  
)

export default component.exports